import React from "react";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TreeItem, { TreeItemProps } from "@mui/lab/TreeItem";
import { Network } from "../../services/NetworkApi";

import { EditWrapper } from "../EditWrapper";
import { Button } from "../../UI/MUIButton";
import { IProps as ISubnetworksTreeProps } from "./SubnetworksTree";
// import { MatchingDatesPartial } from "../../components/MatchingDatesPartial";


export interface EnhancedTreeItemSubtitles<T extends string | number | boolean> {
  title: string;
  label?: string;
  value: T;
  options?: any[];
  isCheckbox?: boolean;
  onEdit?: (newValue: T) => Promise<void>;
  isPreview?: boolean;
  maxValue?: number;
}

export interface EnhancedTreeItemButtons {
  label: string;
  handler: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

export interface IProps extends TreeItemProps, ISubnetworksTreeProps {
  name: string;
  title?: string;
  subtitle1?: string;
  subnetwork?: Network;
  onEdit1Success?: (newValue: string) => Promise<void>;
  deleteButton?: React.ReactNode;
  subtitles?: EnhancedTreeItemSubtitles<any>[];
  actionButtons?: EnhancedTreeItemButtons[];
}

export const EnhancedTreeItem: React.FC<IProps> = (props) => {
  const {
    name,
    title,
    subtitle1,
    onEdit1Success,
    deleteButton,
    subtitles,
    subnetwork,
    actionButtons,
    isPreview,
    ...other
  } = props;

  let preview = (subtitle: EnhancedTreeItemSubtitles<any>) => {
    if ((subtitle.isPreview && subtitle.value) || (!subtitle.isCheckbox && subtitle.value)) {
      return <Typography variant="subtitle1">{subtitle.title}</Typography>;
    }
    return;
  };

  let subtitleList = subtitles?.map(subtitle => {
    return subtitle.onEdit && subtitle.title && (subtitle.value || subtitle.value === false) && !props.isPreview ? (
        <EditWrapper
            onEditSuccess={subtitle.onEdit}
            defaultValue={subtitle.isCheckbox? subtitle.value : subtitle.value + ""}
            isCheckbox={subtitle.isCheckbox}
            label={subtitle.label}
            maxValue={subtitle.maxValue}
        >
          <Typography variant="subtitle1">{subtitle.title}</Typography>
        </EditWrapper>
    ) : (
      preview(subtitle)
    );
  });

  let buttonList = actionButtons?.map(button => {
    if (!props.isPreview) {
      return <Grid item>
        <Button variant="outlined" onClick={button.handler}>
          {button.label}
        </Button>
      </Grid>;
    }
  });

  return (
    <TreeItem
      {...(other as any)}
      label={
        <Grid container spacing={1} alignItems="center" sx={{ p: 1 }}>
          <Grid item xs>
            {!props.isPreview && (
              <EditWrapper
                onEditSuccess={props.onEdit1Success}
                defaultValue={props.name}
                deleteButton={deleteButton}
              >
                <Typography variant="h6">{title}</Typography>
              </EditWrapper>
            )}
            {props.isPreview && <Typography variant="h6">{title}</Typography>}
            {!props.isPreview && (
              <Typography variant="subtitle1">{subtitle1}</Typography>
            )}
            {subtitleList}
            {isPreview && subtitle1 && <Typography variant="subtitle1">{subtitle1}</Typography>}
            {/* {!props.isPreview && subnetwork && <MatchingDatesPartial subnetwork={subnetwork} />} */}
           
          </Grid>
          {buttonList}
        </Grid>
      }
    />
  );
};
